// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Float from "@rescript/core/src/Core__Float.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Modal$OrcaPaymentPage from "../Components/Modal.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "../Components/RenderIf.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "../Utilities/PaymentHelpers.bs.js";

function getKeyValue(json, str) {
  return Core__Option.getOr(Core__JSON.Decode.string(Core__Option.getOr(json[str], {})), "");
}

function parsePaymentMethod(methodString) {
  if (methodString === "duit_now") {
    return "DuitNow";
  } else {
    return "Other";
  }
}

var baseConfig = {
  defaultColor: "transparent",
  showBorder: false,
  footerText: "",
  showLogo: false,
  color: "",
  logoName: ""
};

function getPaymentMethodConfig(method) {
  if (method === "DuitNow") {
    return {
            defaultColor: "#ED2E67",
            showBorder: true,
            footerText: "MALAYSIA NATIONAL QR",
            showLogo: true,
            color: "",
            logoName: "duitNow"
          };
  } else {
    return baseConfig;
  }
}

function QRCodeDisplay(props) {
  var match = React.useState(function () {
        return "";
      });
  var setQrCode = match[1];
  var match$1 = React.useState(function () {
        return "";
      });
  var setRawQrData = match$1[1];
  var rawQrData = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setIsCopied = match$2[1];
  var match$3 = React.useState(function () {
        return 900000.0;
      });
  var setExpiryTime = match$3[1];
  var expiryTime = match$3[0];
  var match$4 = React.useState(function () {
        return false;
      });
  var setOpenModal = match$4[1];
  var match$5 = React.useState(function () {
        return "";
      });
  var setReturnUrl = match$5[1];
  var return_url = match$5[0];
  var match$6 = React.useState(function () {
        return "";
      });
  var setClientSecret = match$6[1];
  var clientSecret = match$6[0];
  var match$7 = React.useState(function () {
        return "";
      });
  var setSdkAuthorization = match$7[1];
  var sdkAuthorization = match$7[0];
  var match$8 = React.useState(function () {
        return [];
      });
  var setHeaders = match$8[1];
  var headers = match$8[0];
  var match$9 = React.useState(function () {
        return "";
      });
  var setPublishableKey = match$9[1];
  var publishableKey = match$9[0];
  var logger = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var customPodUri = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.customPodUri);
  var match$10 = React.useState(function () {
        return baseConfig;
      });
  var setPaymentMethodConfig = match$10[1];
  var paymentMethodConfig = match$10[0];
  var copyTimeoutRef = React.useRef(undefined);
  React.useEffect((function () {
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                  "iframeMountedCallback",
                  true
                ]]);
          var handle = function (ev) {
            var handleAsync = async function () {
              var json = Utils$OrcaPaymentPage.safeParse(ev.data);
              var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
              if (!Core__Option.isSome(dict["fullScreenIframeMounted"])) {
                return ;
              }
              var metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata");
              var metaDataDict = Core__Option.getOr(Core__JSON.Decode.object(metadata), {});
              var paymentMethodStr = Utils$OrcaPaymentPage.getString(metaDataDict, "paymentMethod", "");
              var parsedPaymentMethod = parsePaymentMethod(paymentMethodStr);
              var defaultConfig = getPaymentMethodConfig(parsedPaymentMethod);
              var qrData = Utils$OrcaPaymentPage.getString(metaDataDict, "qrData", "");
              var rawQrData = Utils$OrcaPaymentPage.getString(metaDataDict, "rawQrData", "");
              var publishableKey = Utils$OrcaPaymentPage.getString(metaDataDict, "publishableKey", "");
              setPublishableKey(function (param) {
                    return publishableKey;
                  });
              setQrCode(function (param) {
                    return qrData;
                  });
              setRawQrData(function (param) {
                    return rawQrData;
                  });
              if (parsedPaymentMethod === "DuitNow") {
                var displayText = Utils$OrcaPaymentPage.getString(metaDataDict, "display_text", defaultConfig.footerText);
                var borderColor = Utils$OrcaPaymentPage.getString(metaDataDict, "border_color", defaultConfig.defaultColor);
                var displayText$1 = displayText === "" ? defaultConfig.footerText : displayText;
                var borderColor$1 = borderColor === "" ? defaultConfig.defaultColor : borderColor;
                var showBorder = displayText$1 !== "" && borderColor$1 !== "";
                setPaymentMethodConfig(function (param) {
                      return {
                              defaultColor: defaultConfig.defaultColor,
                              showBorder: showBorder,
                              footerText: displayText$1,
                              showLogo: defaultConfig.showLogo,
                              color: borderColor$1,
                              logoName: defaultConfig.logoName
                            };
                    });
              } else {
                setPaymentMethodConfig(function (param) {
                      return defaultConfig;
                    });
              }
              var paymentIntentId = Utils$OrcaPaymentPage.getString(metaDataDict, "paymentIntentId", "");
              setClientSecret(function (param) {
                    return paymentIntentId;
                  });
              var sdkAuthorizationVal = Utils$OrcaPaymentPage.getString(metaDataDict, "sdkAuthorization", "");
              setSdkAuthorization(function (param) {
                    return sdkAuthorizationVal;
                  });
              var headersDict = Core__Option.getOr(Core__JSON.Decode.object(Utils$OrcaPaymentPage.getJsonObjectFromDict(metaDataDict, "headers")), {});
              var headers = {};
              setReturnUrl(function (param) {
                    return Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(metadata), "url", "");
                  });
              Object.entries(headersDict).forEach(function (entries) {
                    headers[entries[0]] = Utils$OrcaPaymentPage.getStringFromJson(entries[1], "");
                  });
              var expiryTime = Core__Option.getOr(Core__Float.fromString(Utils$OrcaPaymentPage.getString(metaDataDict, "expiryTime", "")), 0.0);
              var timeExpiry = expiryTime - Date.now();
              if (timeExpiry > 0.0 && timeExpiry < 900000.0) {
                setExpiryTime(function (param) {
                      return timeExpiry;
                    });
              }
              setHeaders(function (param) {
                    return Object.entries(headers);
                  });
              try {
                var res = await PaymentHelpers$OrcaPaymentPage.pollRetrievePaymentIntent(paymentIntentId, Object.fromEntries(Object.entries(headers)), publishableKey, logger, customPodUri, undefined, Caml_option.some(sdkAuthorizationVal));
                Modal$OrcaPaymentPage.close(setOpenModal);
                return Utils$OrcaPaymentPage.postSubmitResponse(res, return_url);
              }
              catch (raw_error){
                var error = Caml_js_exceptions.internalToOCamlException(raw_error);
                console.error("Error while polling payment intent:", error);
                return ;
              }
            };
            handleAsync();
          };
          window.addEventListener("message", handle);
          return (function () {
                    window.removeEventListener("message", handle);
                  });
        }), []);
  var closeModal = async function () {
    try {
      var json = await PaymentHelpers$OrcaPaymentPage.retrievePaymentIntent(clientSecret, Object.fromEntries(headers), publishableKey, logger, customPodUri, undefined, Caml_option.some(sdkAuthorization));
      Utils$OrcaPaymentPage.postSubmitResponse(json, return_url);
      return Modal$OrcaPaymentPage.close(setOpenModal);
    }
    catch (raw_e){
      var e = Caml_js_exceptions.internalToOCamlException(raw_e);
      console.error("Retrieve Failed", e);
      return ;
    }
  };
  React.useEffect((function () {
          if (expiryTime < 1000.0) {
            closeModal();
          }
          var intervalID = setInterval((function () {
                  setExpiryTime(function (prev) {
                        return prev - 1000.0;
                      });
                }), 1000);
          return (function () {
                    clearInterval(intervalID);
                  });
        }), [expiryTime]);
  var expiryString = React.useMemo((function () {
          var minutes = (expiryTime / 60000.0 | 0).toString();
          var seconds = ((expiryTime | 0) % 60000 / 1000 | 0).toString();
          var formatedSeconds = seconds.length === 1 ? "0" + seconds : seconds;
          return minutes + ":" + formatedSeconds;
        }), [expiryTime]);
  var handleCopyQrData = function (param) {
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [
          [
            "copy",
            true
          ],
          [
            "copyDetails",
            rawQrData
          ]
        ]);
    var id = copyTimeoutRef.current;
    if (id !== undefined) {
      clearTimeout(Caml_option.valFromOption(id));
    }
    setIsCopied(function (param) {
          return true;
        });
    var id$1 = setTimeout((function () {
            setIsCopied(function (param) {
                  return false;
                });
            copyTimeoutRef.current = undefined;
          }), 1000);
    copyTimeoutRef.current = Caml_option.some(id$1);
  };
  var displayColor = React.useMemo((function () {
          if (!Utils$OrcaPaymentPage.isValidHexColor(paymentMethodConfig.color) || paymentMethodConfig.color === "") {
            return paymentMethodConfig.defaultColor;
          } else {
            return paymentMethodConfig.color;
          }
        }), [
        paymentMethodConfig.color,
        paymentMethodConfig.defaultColor
      ]);
  var isRawQrDataAvailable = rawQrData.length > 0;
  var qrBottomSectionMarginClass = isRawQrDataAvailable ? "mt-6" : "mt-16";
  return React.createElement(Modal$OrcaPaymentPage.make, {
              children: React.createElement("div", {
                    className: "flex flex-col h-full justify-between items-center"
                  }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                        condition: paymentMethodConfig.showLogo && paymentMethodConfig.logoName !== "",
                        children: React.createElement("div", {
                              className: "flex flex-row w-full justify-center items-start mb-2"
                            }, React.createElement(Icon$OrcaPaymentPage.make, {
                                  name: paymentMethodConfig.logoName,
                                  size: 84,
                                  width: 84
                                }))
                      }), React.createElement("div", {
                        className: "flex flex-row w-full justify-center items-start mb-8 font-medium text-2xl font-semibold text-[#151A1F] opacity-50"
                      }, expiryString), React.createElement("div", {
                        className: paymentMethodConfig.showBorder ? "border-[1em] rounded-md" : "",
                        style: {
                          backgroundColor: paymentMethodConfig.showBorder ? displayColor : "transparent",
                          borderColor: paymentMethodConfig.showBorder ? displayColor : "transparent"
                        }
                      }, React.createElement("div", {
                            className: paymentMethodConfig.showBorder ? "border-[0.5em] border-white rounded-md" : ""
                          }, React.createElement("img", {
                                style: {
                                  height: "13rem"
                                },
                                alt: "",
                                src: match[0]
                              })), React.createElement(RenderIf$OrcaPaymentPage.make, {
                            condition: paymentMethodConfig.footerText !== "",
                            children: React.createElement("div", {
                                  className: "font-bold flex justify-center items-end text-[1em] text-white h-[2em]",
                                  style: {
                                    backgroundColor: displayColor
                                  }
                                }, React.createElement("p", undefined, paymentMethodConfig.footerText))
                          })), React.createElement("div", {
                        className: "flex flex-col " + qrBottomSectionMarginClass + " max-w-md justify-between items-center"
                      }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                            condition: isRawQrDataAvailable,
                            children: React.createElement("button", {
                                  className: "button mb-6 p-2 h-[40px] border border-[#006DF9] rounded-md",
                                  style: {
                                    background: "transparent",
                                    color: "#006DF9"
                                  },
                                  onClick: handleCopyQrData
                                }, match$2[0] ? "Copied!" : "Copy QR Data")
                          }), React.createElement("div", {
                            className: "Disclaimer w-full  font-medium text-xs text-[#151A1F] opacity-50"
                          }, "The QR Code is valid for the next 15 minutes, please do not close until you have successfully completed the payment, after which you will be automatically redirected."), React.createElement("div", {
                            className: "button w-full"
                          }, React.createElement("div", undefined, React.createElement("button", {
                                    className: "w-full mt-6 p-2 h-[40px]",
                                    style: {
                                      background: "#006DF9",
                                      color: "#ffffff",
                                      borderRadius: "4px"
                                    },
                                    onClick: (function (param) {
                                        closeModal();
                                      })
                                  }, "Done"))))),
              showClose: false,
              setOpenModal: setOpenModal,
              openModal: match$4[0]
            });
}

var copyResetTime = 1000;

var maxQRTime = 900000.0;

var make = QRCodeDisplay;

export {
  copyResetTime ,
  maxQRTime ,
  getKeyValue ,
  parsePaymentMethod ,
  baseConfig ,
  getPaymentMethodConfig ,
  make ,
}
/* react Not a pure module */
